/* Lumora diagonal hero: picture changer + typing effects */
(function () {
  var RM = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var CH = 'abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ#%&*+';

  function panel(p, root) {
    var ims = [].slice.call(p.querySelectorAll('.dg__im'));
    if (ims.length < 2) return;
    var dots = [].slice.call(root.querySelectorAll('.dg__meta--' + (p.classList.contains('dg__p--b') ? 'b' : 'a') + ' .dg__dot'));
    var sec = parseFloat(p.getAttribute('data-sec')) || 4, cur = 0, t = null, paused = false;
    if (RM) p.setAttribute('data-fx', 'fade');
    function go(n) {
      if (n === cur) return;
      var from = ims[cur], to = ims[n];
      ims.forEach(function (im) { if (im !== from && im !== to) im.classList.remove('is-on', 'is-out'); });
      from.classList.remove('is-on'); from.classList.add('is-out');
      to.classList.remove('is-out'); void to.offsetWidth; to.classList.add('is-on');
      dots.forEach(function (d, i) { d.classList.toggle('is-on', i === n); });
      var old = from; cur = n;
      setTimeout(function () { if (old !== ims[cur]) old.classList.remove('is-out'); }, 1300);
    }
    function next() { go((cur + 1) % ims.length); }
    function start() { stop(); t = setInterval(function () { if (!paused && !document.hidden) next(); }, sec * 1000); }
    function stop() { if (t) clearInterval(t); t = null; }
    dots.forEach(function (d, i) { d.addEventListener('click', function (e) { e.stopPropagation(); go(i); start(); }); });
    if (root.getAttribute('data-pause') === '1') {
      p.addEventListener('mouseenter', function () { paused = true; });
      p.addEventListener('mouseleave', function () { paused = false; });
    }
    /* second block starts half a turn later so they never change together */
    setTimeout(start, p.classList.contains('dg__p--b') ? sec * 500 : 0);
  }

  function typeOnce(el, text, speed, done) {
    if (RM) { el.textContent = text; if (done) done(); return; }
    el.textContent = ''; var i = 0;
    (function step() {
      el.textContent = text.slice(0, ++i);
      if (i < text.length) setTimeout(step, speed); else if (done) done();
    })();
  }

  function scramble(el, to, done) {
    if (RM) { el.textContent = to; if (done) done(); return; }
    var f = 0, total = 18;
    var id = setInterval(function () {
      f++; var out = '', k = Math.floor(to.length * f / total);
      for (var i = 0; i < to.length; i++) out += i < k || to[i] === ' ' ? to[i] : CH[Math.floor(Math.random() * CH.length)];
      el.textContent = out;
      if (f >= total) { clearInterval(id); el.textContent = to; if (done) done(); }
    }, 45);
  }

  function words(ty) {
    var el = ty.querySelector('.dg__tyt');
    var list = (ty.getAttribute('data-words') || '').split('|').map(function (w) { return w.replace(/^\s+|\s+$/g, ''); }).filter(Boolean);
    var fx = ty.getAttribute('data-fx') || 'loop';
    var speed = parseInt(ty.getAttribute('data-speed'), 10) || 70;
    var hold = (parseFloat(ty.getAttribute('data-hold')) || 2) * 1000;
    if (!list.length || fx === 'none') return;
    if (RM && (fx === 'loop' || fx === 'once' || fx === 'scramble')) fx = 'fade';
    var i = 0;
    function swap(txt, cls) {
      el.className = 'dg__tyt'; void el.offsetWidth;
      el.textContent = txt; if (cls) el.classList.add(cls);
    }
    if (fx === 'loop' || fx === 'once') {
      function cycle() {
        typeOnce(el, list[i], speed, function () {
          if (fx === 'once' && i === list.length - 1) return;
          setTimeout(function () {
            var s = list[i], n = s.length;
            (function erase() {
              n--; el.textContent = s.slice(0, Math.max(n, 0));
              if (n > 0) setTimeout(erase, Math.max(18, speed * 0.45));
              else { i = (i + 1) % list.length; setTimeout(cycle, 260); }
            })();
          }, hold);
        });
      }
      if (fx === 'once') { i = 0; }
      setTimeout(cycle, 700);
    } else if (fx === 'scramble') {
      setInterval(function () { i = (i + 1) % list.length; scramble(el, list[i]); }, hold + 700);
    } else {
      setInterval(function () { i = (i + 1) % list.length; swap(list[i], 'fx-' + fx); }, hold + 600);
    }
  }


  /* make the text fit its box */
  function fit(root) {
    var mode = root.getAttribute('data-fit'), box = root.querySelector('.dg__box');
    if (!box) return;
    box.style.setProperty('--fit', 1); box.style.setProperty('--fit2', 1);
    if (mode === 'off') return;
    var h = box.querySelector('.dg__h'); if (!h) return;
    var cs = getComputedStyle(box);
    var inner = box.clientWidth - parseFloat(cs.paddingLeft) - parseFloat(cs.paddingRight) - (parseFloat(cs.borderLeftWidth) || 0) - (parseFloat(cs.borderRightWidth) || 0);
    var ph = window.matchMedia('(max-width: 749px)').matches;
    if (root.getAttribute(ph ? 'data-tdm' : 'data-td') === '5') inner = inner * 0.82;
    var max = 0;
    function meas(host, txt) {
      var m = document.createElement('span');
      m.style.cssText = 'position:absolute;visibility:hidden;white-space:nowrap;left:0;top:0;font:inherit;letter-spacing:inherit;pointer-events:none';
      m.textContent = txt; host.appendChild(m); var w = m.offsetWidth; host.removeChild(m); return w;
    }
    var l1 = h.querySelector('.dg__l1'); if (l1) max = Math.max(max, meas(l1, l1.textContent));
    var ty = h.querySelector('.dg__ty');
    if (ty) (ty.getAttribute('data-words') || '').split('|').forEach(function (w) { w = w.replace(/^\s+|\s+$/g, ''); if (w) max = Math.max(max, meas(ty, w)); });
    if (!max || inner <= 0) return;
    var k = inner / max;
    k = mode === 'fill' ? Math.max(.45, Math.min(k * .98, 1.6)) : Math.min(k * .98, 1);
    box.style.setProperty('--fit', k.toFixed(3));
    box.style.setProperty('--fit2', Math.max(.7, Math.min(1.25, .6 + .4 * k)).toFixed(3));
  }
  function init(root) {
    if (root.__dg) return; root.__dg = 1;
    var tmr; function refit() { clearTimeout(tmr); tmr = setTimeout(function () { fit(root); }, 60); }
    fit(root); window.addEventListener('resize', refit); if (document.fonts && document.fonts.ready) document.fonts.ready.then(function () { fit(root); });
    if (window.ResizeObserver) { var bx = root.querySelector('.dg__box'); if (bx) new ResizeObserver(refit).observe(root); }
    [].slice.call(root.querySelectorAll('.dg__p')).forEach(function (p) { panel(p, root); });
    [].slice.call(root.querySelectorAll('.dg__ty')).forEach(words);
    var l1 = root.querySelector('.dg__l1[data-hfx="type"]');
    if (l1) { var tx = l1.textContent; l1.setAttribute('aria-label', tx); typeOnce(l1, tx, 55); }
    var l2 = root.querySelector('.dg__l1[data-hfx="blur"]'); if (l2) l2.style.animation = 'dg-tb 1s ease both';
    var sb = root.querySelector('.dg__sub[data-sfx2="type"]');
    if (sb) { var st = sb.textContent; sb.setAttribute('aria-label', st); setTimeout(function () { typeOnce(sb, st, 22); }, 600); }
  }
  function boot() { [].slice.call(document.querySelectorAll('[data-dg]')).forEach(init); }
  if (document.readyState !== 'loading') boot(); else document.addEventListener('DOMContentLoaded', boot);
  document.addEventListener('shopify:section:load', boot);
})();
